import { i18n } from '@/libs/i18n';

export const getLanguageDisplayModalError = (): string => {
  switch (i18n.global.locale) {
    case 'en-US':
      return 'en-us';
    case 'th':
      return 'th-th';
    default:
      return 'th-th';
  }
};

export const resolveTranslation = (translationJson: string, fallback: string) => {
  const currentLang = i18n.global.locale == 'th' ? 'th-TH' : 'en-US'
  if (!translationJson) return fallback;

  try {
    const translations = typeof translationJson === 'string' ? JSON.parse(translationJson) : translationJson;

    return translations[currentLang] ?? translations['en-US'] ?? fallback;
  } catch {
    return fallback;
  }
};
